import React, { useState } from 'react';
import SuccessToast from '../../toast/SuccessToast';
import AddTransaction from '../Modals/AddTransaction';
import { amountDisplay } from '../../util/helper';
import RevealValue from '../RevealValue';
import { useLanguage } from '../../context/LanguageContext';

function CardSummary({ user, summary, refreshHome }) {
    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const { t, language } = useLanguage();

    const handleShow = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleTransactionAdd = () => {
        refreshHome();
    };

    return (
        <section className="section-b-space">
            <div className="custom-container">
                <div className="card-box">
                    <div className="card-details">
                        <div className="d-flex justify-content-between">
                            <h5 className="fw-semibold">{t('balance')}</h5>
                            <img src={'assets/images/svg/ellipse.svg'} alt="ellipse" />
                        </div>

                        <h1 className="mt-2 text-white">
                            <RevealValue
                                value={amountDisplay(summary.totalBalance, language)}
                                format={user.currency === 'USD' ? '$' : '৳'}
                                initiallyMasked={true}
                                autoHideMs={3000}
                            />
                        </h1>

                        <div className="amount-details">
                            <div className="amount w-50 text-start">
                                <div className="d-flex align-items-center justify-content-start">
                                    <img
                                        className="img-fluid icon"
                                        src={'assets/images/svg/arrow-down-right.svg'}
                                        alt="down"
                                    />
                                    <h5>{t('income')}</h5>
                                </div>
                                <h3 className="text-white">
                                    {user.currency === 'USD' ? '$' : '৳'}{' '}
                                    {amountDisplay(summary.income, language)}
                                </h3>
                            </div>
                            <div className="amount w-50 text-end border-0">
                                <div className="d-flex align-items-center justify-content-end">
                                    <img
                                        className="img-fluid icon"
                                        src={'assets/images/svg/arrow-up-right.svg'}
                                        alt="up"
                                    />
                                    <h5>{t('expense')}</h5>
                                </div>
                                <h3 className="text-white">
                                    {user.currency === 'USD' ? '$' : '৳'}{' '}
                                    {amountDisplay(summary.expense, language)}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <button onClick={handleShow} className="add-money theme-color">
                        {t('addMoney')}
                    </button>
                </div>
            </div>
            {showModal && (
                <AddTransaction
                    show={showModal}
                    onClose={handleClose}
                    setShowToast={setShowToast}
                    onTransactionAdd={handleTransactionAdd}
                    transactionType="income"
                />
            )}

            {showToast && (
                <SuccessToast
                    message={t('transactionSuccessful')}
                    onClose={() => setShowToast(false)}
                />
            )}
        </section>
    );
}

export default CardSummary;
